type EmbedYoutubeVideoProps = {
  url: string;
};
const EmbedYoutubeVideo = ({ url }: EmbedYoutubeVideoProps) => {
  // Use URL object to safely parse the ID
  const getEmbedId = (link: string) => {
    try {
      const urlObj = new URL(link);
      return urlObj.searchParams.get("v");
    } catch (e) {
      return null;
    }
  };

  const embedId = getEmbedId(url);

  return (
    embedId && (
      <div className="aspect-video w-full">
        <iframe
          className="h-full w-full rounded-lg"
          src={`https://www.youtube.com/embed/${embedId}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    )
  );
};

export default EmbedYoutubeVideo;
